import { gql } from '@apollo/client';

export const GET_PROFILE_MARBLES = gql`
  query getProfileMarbles {
    marblesMe {
      username
      name
      status
      allowedUserActions
      enabledModules
    }
  }
`;
